// extracted by mini-css-extract-plugin
module.exports = {"form":"AssignmentForm_form__2-YfQ"};